import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Link from '@ux/link';
import NavItem from './NavItem';
import { MenuList } from '@ux/menu';
import { NavBarItemPropTypes } from './NavBarItem';
import { makeUniqueItemKey } from './utils';
import { useGetWindowHref } from '../../lib/useGetWindowHref';
import { isNavItemActive } from '../../lib/linkUtils';

const NavBarItemChildren = ({ items = [] }) => {
  const browserUrlStr = useGetWindowHref();

  const itemsJsx = useMemo(() => {
    return items.map((item, index) => (
      <NavItem
        as={ Link }
        active={ item.active ?? isNavItemActive(item, browserUrlStr) }
        id={ item.id }
        href={ item.href || '#' }
        key={ makeUniqueItemKey(item, index, 'tray-item') }
        target={ item.target }
        onSelect={ item.onClick }
        data-eid={ item.eid }
        icon={ item.icon }
        badge={ item.badge }
        { ...item.dataAttrs }>
        { item.caption || item.title }
      </NavItem>
    ));
  }, [browserUrlStr, items]);

  return (
    <MenuList className='in-page-flyout'>
      { itemsJsx }
    </MenuList>
  );
};

NavBarItemChildren.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(NavBarItemPropTypes))
};

export default NavBarItemChildren;
